import React, { useEffect, useState } from 'react';
import { remoteConfig } from '../services/Firebase';


function useGetFirebaseFeatureFlag(configBooleanName: string) {
    const [enableFeature, setEnableFeature] = useState(false)

    useEffect(() => {
        remoteConfig.fetchAndActivate().then(() => {
            setEnableFeature(remoteConfig.getConfigBoolean(configBooleanName) || false)
        })
    }, [])

    return enableFeature
}

export default useGetFirebaseFeatureFlag
